import { Component, inject } from '@angular/core';
import { ChangableComponent } from '@models/changable.component';
import { VocabularyTerm } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ICard, mainCards } from '../../vocabulary.variables';

@Component({
  selector: 'app-vocabulary-main',
  templateUrl: './vocabulary-main.component.html',
  styleUrls: ['./vocabulary-main.component.scss'],
})
export class VocabularyMainComponent extends ChangableComponent {
  public widgets: ICard[] = mainCards;
  public vocabulary: Partial<VocabularyTerm>;

  deviceService = inject(DeviceDetectorService);

  public onVocabularyChange(e: Partial<VocabularyTerm>) {
    this.vocabulary = e;
  }
}
